import { mountReactFeature } from '../../libs/mountReactFeature'

// Opens the React special-day (suggestion) form. The trigger button carries a
// `data-bootstrap-url` pointing at the new/edit `.json` action (admin vs
// franchisor, new vs edit are all resolved server-side into that URL).
const handleSpecialDayFormClick = async (e) => {
  const button = e.target.closest('.js-special-day-form')
  if (!button) return

  e.preventDefault()

  await mountReactFeature({
    loader: () => import('../../react/containers/SpecialDayFormContainer'),
    i18nLoader: () => import('../../react/locales/special-day-form/i18n'),
    props: { bootstrapUrl: button.getAttribute('data-bootstrap-url') }
  })
}

document.addEventListener('turbolinks:load', () => {
  document.body.removeEventListener('click', handleSpecialDayFormClick)
  document.body.addEventListener('click', handleSpecialDayFormClick)
})
